import React, { Fragment, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Input } from 'components/molecules/v2/input';
import InputWithLabel from 'components/molecules/input-with-label';
import { useAuthState } from 'src/components/auth/hook';
import ResetIcon from 'icons/reset.svg';
import { PARTNER_RESET_PASSWORD } from 'src/formMapper';
import { validationSchema } from './validations';

const ForgotPasswordForm = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { client } = useAuthState();

  const {
    handleSubmit,
    register,
    watch,
    getValues,
    formState: { isSubmitting, errors }
  } = useForm({
    shouldFocusError: false,
    resolver: yupResolver(validationSchema),
    mode: 'onChange'
  });

  const onFormSubmit = async (values) => {
    await client.post('/password/reset/', {
      email: values.email
    });
    setFormSubmitted(true);
  };

  const onChangeEmail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFormSubmitted(false);
  };

  return (
    <>
      {!formSubmitted && (
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <div className='grid grid-cols-1 gap-4 lg:max-w-md'>
            <InputWithLabel
              label={PARTNER_RESET_PASSWORD.email.label}
              name='email'
              error={!!errors.email}
              errorMessage={errors?.email?.message}
              labelSize='large'
            >
              <Input
                name='email'
                type='email'
                placeholder={PARTNER_RESET_PASSWORD.email.placeholder}
                error={!!errors.email}
                errorMessage={errors?.email?.message}
                register={register}
                value={watch('email')}
              />
            </InputWithLabel>
          </div>
          <div className='mt-8'>
            <button
              type='submit'
              disabled={isSubmitting}
              aria-disabled={isSubmitting}
              className='space-x-2 app-btn app-btn-primary group'
              data-testid='submit'
            >
              <ResetIcon />
              <span>{PARTNER_RESET_PASSWORD.button.submit}</span>
            </button>
          </div>
        </form>
      )}
      {formSubmitted && (
        <div className='pt-2 pb-8'>
          <div className='px-[10px] py-2 border border-green-400 rounded-full bg-green-50 inline-block'>
            <div className='flex items-center'>
              <div className='flex-shrink-0'>
                <img src='/icons/success-icon.svg' className='w-[18px] h-[18px]' />
              </div>
              <div className='ml-2'>
                <p className='app-text-dm-small text-gray text-opacity-80' data-testid='success-reset-link'>
                  Email sent successfully on {getValues('email')}
                </p>
              </div>
            </div>
          </div>
          <div className='mt-4'>
            <p className='space-x-1 leading-snug app-text-dm-small text-gray opacity-90'>
              Email ID incorrect?
              <a href='#' onClick={onChangeEmail} data-testid='change-email-id'>
                <span className='uppercase app-text-link text-secondary'> change id here</span>
              </a>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

ForgotPasswordForm.propTypes = {};

export default ForgotPasswordForm;
